"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Collapse = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var IconButton_1 = require("../IconButton/IconButton");
var Collapse_1 = tslib_1.__importDefault(require("@material-ui/core/Collapse"));
var ArrowDropUp_1 = tslib_1.__importDefault(require("@material-ui/icons/ArrowDropUp"));
var ArrowDropDown_1 = tslib_1.__importDefault(require("@material-ui/icons/ArrowDropDown"));
var Collapse_styles_1 = require("./Collapse.styles");
var enums_1 = require("../../enums");
var core_1 = require("@material-ui/core");
var Collapse = function (_a) {
    var children = _a.children, title = _a.title, label = _a.label, expanded = _a.expanded, handleExpandClick = _a.handleExpandClick;
    var classes = (0, Collapse_styles_1.useCollapseStyles)();
    return (react_1.default.createElement("div", { className: classes.main, "data-signa": "collapse-container" },
        react_1.default.createElement("div", { className: classes.container, "data-signa": "collapse-action", onClick: handleExpandClick },
            react_1.default.createElement(IconButton_1.IconButton, { variant: enums_1.Variant.contained, color: enums_1.Color.secondary, size: enums_1.Size.extraSmall, disabled: false, onClick: function () { return null; }, name: label },
                expanded && react_1.default.createElement(ArrowDropUp_1.default, { fontSize: "inherit" }),
                !expanded && react_1.default.createElement(ArrowDropDown_1.default, { fontSize: "inherit" })),
            react_1.default.createElement(core_1.Typography, { className: classes.title, variant: "body1" }, title)),
        react_1.default.createElement(Collapse_1.default, { in: expanded, timeout: "auto", unmountOnExit: true }, children)));
};
exports.Collapse = Collapse;
